module.exports = __webpack_public_path__ + "baadf0f398d780e7dab2bbf5115cbcf9.woff";